import { render } from "./IndexPaymentCenterAuth.vue?vue&type=template&id=2eeb5756"
import script from "./IndexPaymentCenterAuth.vue?vue&type=script&lang=js"
export * from "./IndexPaymentCenterAuth.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__